import { useState, useRef, useCallback, useEffect } from "react";
const IMAGE_LOAD_TIMEOUT_MS = 5e3;
const FONT_LOAD_TIMEOUT_MS = 5e3;
function waitForNextFrame() {
  return new Promise((resolve) => requestAnimationFrame(() => resolve()));
}
function waitForImage(img) {
  if (img.complete) return waitForNextFrame();
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      img.removeEventListener("load", finish);
      img.removeEventListener("error", finish);
      void waitForNextFrame().then(resolve);
    };
    const timeoutId = setTimeout(finish, IMAGE_LOAD_TIMEOUT_MS);
    img.addEventListener("load", finish, { once: true });
    img.addEventListener("error", finish, { once: true });
    if (img.complete) finish();
  });
}
function waitForImages(container) {
  const images = container.querySelectorAll("img");
  const promises = Array.from(images).map(waitForImage);
  return Promise.all(promises).then(() => {
  });
}
function waitForFonts() {
  if (typeof document === "undefined" || !document.fonts) {
    return Promise.resolve();
  }
  const ready = document.fonts.ready;
  if (!ready || typeof ready.then !== "function") return Promise.resolve();
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      resolve();
    };
    const timeoutId = setTimeout(finish, FONT_LOAD_TIMEOUT_MS);
    ready.then(finish, finish);
  });
}
function useQuizMeasurement(measureRef, quizScripts, deps) {
  const [measuredHeights, setMeasuredHeights] = useState([]);
  const [isMeasuring, setIsMeasuring] = useState(false);
  const counterRef = useRef(0);
  const measure = useCallback(() => {
    if (!measureRef.current || quizScripts.length === 0) {
      setMeasuredHeights([]);
      setIsMeasuring(false);
      return;
    }
    setIsMeasuring(true);
    const id = ++counterRef.current;
    requestAnimationFrame(() => {
      const container = measureRef.current;
      if (!container || id !== counterRef.current) return;
      Promise.all([waitForImages(container), waitForFonts()]).then(() => {
        if (id !== counterRef.current) return;
        requestAnimationFrame(() => {
          if (id !== counterRef.current) return;
          const items = container.querySelectorAll("[data-quiz-measure]");
          const heights = Array.from(items).map((el) => el.getBoundingClientRect().height);
          setMeasuredHeights(heights);
          setIsMeasuring(false);
        });
      });
    });
  }, [measureRef, quizScripts]);
  useEffect(() => {
    measure();
  }, [measure, ...deps ?? []]);
  return { measuredHeights, isMeasuring, remeasure: measure };
}
export {
  useQuizMeasurement
};
//# sourceMappingURL=useQuizMeasurement.js.map
